import apiService from '../../../services/apiService';

const TIFFIN_API = '/ykrestapi/Tiffin';

export const tiffinService = {
  getMealType: async (paramRequestItem) => {
    try {
      const response = await apiService.post(`${TIFFIN_API}/GetMealType`, paramRequestItem);
      return response.data;
    } catch (error) {
      console.error('Error fetching meal types:', error);
      throw error;
    }
  },

  getMenuDetail: async (menuParameters) => {
    try {
      const response = await apiService.post(`${TIFFIN_API}/GetMenuDetail`, menuParameters);
      return response.data;
    } catch (error) {
      console.error('Error fetching menu details:', error);
      throw error;
    }
  },

  getPlansByCenter: async (centerId) => {
    try {
      const response = await apiService.post(`${TIFFIN_API}/GetMenuDetail`, {
        centerId,
      });
      return response.data;
    } catch (error) {
      console.error('Error fetching plans:', error);
      throw error;
    }
  },

  getPlanDetails: async (planId) => {
    try {
      const response = await apiService.post(`${TIFFIN_API}/GetMenuDetail`, {
        planId,
      });
      return response.data;
    } catch (error) {
      console.error('Error fetching plan details:', error);
      throw error;
    }
  },

  getMealsForPlan: async (planId) => {
    try {
      const response = await apiService.post(`${TIFFIN_API}/GetMenuDetail`, {
        planId,
      });
      return response.data;
    } catch (error) {
      console.error('Error fetching meals:', error);
      throw error;
    }
  },

  subscribe: async (subscriptionData) => {
    try {
      const response = await apiService.post(`${TIFFIN_API}/Subscribe`, subscriptionData);
      return response.data;
    } catch (error) {
      console.error('Error subscribing:', error);
      throw error;
    }
  },

  updateSubscription: async (subscriptionId, data) => {
    try {
      const response = await apiService.post(`${TIFFIN_API}/UpdateSubscription`, {
        subscriptionId,
        ...data,
      });
      return response.data;
    } catch (error) {
      console.error('Error updating subscription:', error);
      throw error;
    }
  },

  getSubscriptionDetails: async (subscriptionId) => {
    try {
      const response = await apiService.post(`${TIFFIN_API}/GetSubscriptionDetails`, {
        subscriptionId,
      });
      return response.data;
    } catch (error) {
      console.error('Error fetching subscription details:', error);
      throw error;
    }
  },

  getDeliveries: async (subscriptionId) => {
    try {
      const response = await apiService.post(`${TIFFIN_API}/GetDeliveries`, {
        subscriptionId,
      });
      return response.data;
    } catch (error) {
      console.error('Error fetching deliveries:', error);
      throw error;
    }
  },

  submitPayment: async (paymentData) => {
    try {
      const response = await apiService.post(`${TIFFIN_API}/SubmitPayment`, paymentData);
      return response.data;
    } catch (error) {
      console.error('Error submitting payment:', error);
      throw error;
    }
  },

  getUserSubscriptions: async (userId) => {
    try {
      const response = await apiService.post(`${TIFFIN_API}/GetUserSubscriptions`, {
        userId,
      });
      return response.data;
    } catch (error) {
      console.error('Error fetching user subscriptions:', error);
      throw error;
    }
  },

  cancelSubscription: async (subscriptionId) => {
    try {
      const response = await apiService.post(`${TIFFIN_API}/CancelSubscription`, {
        subscriptionId,
      });
      return response.data;
    } catch (error) {
      console.error('Error canceling subscription:', error);
      throw error;
    }
  },

  pauseSubscription: async (subscriptionId) => {
    try {
      const response = await apiService.post(`${TIFFIN_API}/PauseSubscription`, {
        subscriptionId,
      });
      return response.data;
    } catch (error) {
      console.error('Error pausing subscription:', error);
      throw error;
    }
  },

  resumeSubscription: async (subscriptionId) => {
    try {
      const response = await apiService.post(`${TIFFIN_API}/ResumeSubscription`, {
        subscriptionId,
      });
      return response.data;
    } catch (error) {
      console.error('Error resuming subscription:', error);
      throw error;
    }
  },

  getKitchenMenu: async (date, menuType) => {
    try {
      const response = await apiService.get(`${TIFFIN_API}/kitchen-menu?date=${date}&menuType=${menuType}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching kitchen menu:', error);
      throw error;
    }
  },
};

export default tiffinService;
